import React, { useState } from "react";
import CustomModal from "../../packages/common-utilities/core/modal";
import {
  Button,
  TextField,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Stack from "@mui/material/Stack";
import { toast } from "react-toastify";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { INTRANETHOSTNAME } from "../../packages/common-utilities/utils/end-points";
import { REST_URLS } from "../../packages/common-utilities/utils/end-points/intranet";
import { getOfflineData, setOfflineData } from "../../utils/offline-services";

export const ChangePasswordModal = ({
  showChangePasswordModal,
  setShowChangePasswordModal,
}) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const changePasswordHandler = () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("Please fill all fields", { autoClose: 2000 });
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match", {
        autoClose: 2000,
      });
      return;
    }
    if (newPassword.length < 8) {
      toast.error("Password must be at least 8 characters long", {
        autoClose: 2000,
      });
      return;
    }
    if (newPassword === currentPassword) {
      toast.error("New password cannot be same as current password", {
        autoClose: 2000,
      });
      return;
    }

    invokeApi(
      HTTP_METHODS.POST,
      `${INTRANETHOSTNAME}${REST_URLS.CHANGE_PASSWORD}`,
      {
        oldPassword: currentPassword,
        newPassword: newPassword,
      }
    )
      .then((res) => {
        if (res?.message) {
          toast.error(res?.message, { autoClose: 2000 });
        } else {
          toast.success("Password changed successfully", { autoClose: 2000 });
          setOfflineData("user", res?.user);
          setShowChangePasswordModal(false);
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
        }
      })
      .catch((err) => {
        toast.error(err, { autoClose: 2000 });
      });
  };

  return (
    <>
      {showChangePasswordModal && (
        <CustomModal
          doNotClose={true}
          title="Change Password"
          contentClassName={{ headerBackgroundColor: "#008952" }}
        >
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="currentPassword"
              type={showCurrentPassword ? "text" : "password"}
              style={{ marginBottom: "2em" }}
              label="Current Password"
              onChange={(e) => {
                setCurrentPassword(e.target.value);
              }}
              variant="outlined"
              value={currentPassword}
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        setShowCurrentPassword(!showCurrentPassword)
                      }
                      edge="end"
                    >
                      {showCurrentPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              fullWidth
              id="newPassword"
              type={showNewPassword ? "text" : "password"}
              style={{ marginBottom: "2em" }}
              label="New Password"
              onChange={(e) => {
                setNewPassword(e.target.value);
              }}
              variant="outlined"
              value={newPassword}
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      edge="end"
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              fullWidth
              id="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              style={{ marginBottom: "2em" }}
              label="Confirm New Password"
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}
              variant="outlined"
              value={confirmPassword}
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Stack direction="row" spacing={2} sx={{ my: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={changePasswordHandler}
                fullWidth
              >
                Change Password
              </Button>
            </Stack>
          </Box>
        </CustomModal>
      )}
    </>
  );
};
